import { memo } from 'react';
import cn from 'classnames';
import { Element } from '@zmedia/bm-soccer-ui/components';
import styles from '../style.module.scss';
import { twMerge } from 'tailwind-merge';

function TableHeader({ hasMatchRecent }: { hasMatchRecent: boolean }) {
    const className = cn(
        'th',
        'text-[1.2rem] leading-[1.8rem] text-[var(--black-50)] font-medium',
        'text-center',
        'w-[6rem]'
    );
    return (
        <Element className={styles['thead']}>
            <Element className={styles['tr']}>
                <Element renderAs="span" className={className}>
                    #
                </Element>
                <Element renderAs="span" className={className}>
                    Đội bóng
                </Element>
                <Element renderAs="span" className={className}>
                    Trận
                </Element>
                <Element renderAs="span" className={className}>
                    Thắng
                </Element>
                <Element renderAs="span" className={className}>
                    Hòa
                </Element>
                <Element renderAs="span" className={className}>
                    Thua
                </Element>
                <Element renderAs="span" className={className}>
                    +/-
                </Element>
                <Element renderAs="span" className={className}>
                    Hiệu số
                </Element>
                <Element renderAs="span" className={className}>
                    Điểm
                </Element>
                <Element
                    renderAs="span"
                    className={twMerge(className, 'w-[150px] mr-[24px]')}
                    style={Object.assign(
                        hasMatchRecent ? {} : { display: 'none' }
                    )}
                >
                    Trận gần nhất
                </Element>

                {/* <Element renderAs="span" className={styles['th']}>
                    Kế tiếp
                </Element> */}
            </Element>
        </Element>
    );
}

export default memo(TableHeader);
